// removed by extract-text-webpack-plugin
module.exports = {"canvas":"styles__canvas__kl2JN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Game/styles.less
// module id = 285
// module chunks = 0